import styled, { css, keyframes } from 'styled-components/macro';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: fit-content;
  height: fit-content;
  min-width: 400px;
  border-radius: 16px;
  padding: 16px;
  bottom: 14px;
  right: 14px;
  z-index: 100;

  ${({ theme }) => css`
    border: 1px solid ${theme.colors.gray['200']};
    background-color: ${theme.colors.white};
    animation: ${fadeIn} 150ms ease-in;
    transition: background-color 150ms, border-color 150ms;
  `}
`;

export const QrWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;
